import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import useSWR from 'swr';

import { ADMIN_ACCESS_TOKEN_KEY } from '../../../App';
import { getStartNumber } from '@pages/License/History';
import Worklist from '@components/organisms/Table/Worklist';
import Pagination, { DEFAULT_COUNT_PER_PAGE, DEFAULT_CURRENT_PAGE } from '@components/organisms/Table/Pagination';
import { Sub1Button } from '@components/atoms';
import { Popup } from '@components/templates';
import { Filters } from '@components/organisms';
import { DismissButtonStyle, FilterStyle, LicenseInfoDetail } from './styles';

interface LicenseDetail {
  createdDatetime: string;
  firstName: string;
  id: number;
  lastName: string;
  userId: string;
}

const LicenseDetail = () => {
  const { licenseId } = useParams();
  const [accessToken, setAccessToken] = useState('');
  const [licenseInfo, setLicenseInfo] = useState<any>(null);
  const [valueState, setValueState] = useState({
    searchKey: '',
    searchKeyword: '',
    searchDateType: '',
    dateRange: { startDate: '', endDate: '' },
  });
  const [pageConditionsValue, setPageConditionsValue] = useState({
    countPerPage: DEFAULT_COUNT_PER_PAGE,
    currentPage: DEFAULT_CURRENT_PAGE,
    totalCount: 1,
    'order.name': 'id',
    'order.sort': 'DESC',
  });
  const { countPerPage, currentPage, totalCount } = pageConditionsValue;
  const { searchKey, searchKeyword, searchDateType, dateRange } = valueState;

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken) {
      setAccessToken(newToken);
    }
  }, []);

  useEffect(() => {
    if (valueState)
      setPageConditionsValue((prev) => ({
        ...prev,
        currentPage: DEFAULT_CURRENT_PAGE,
      }));
  }, [valueState]);

  useEffect(() => {
    const saved = sessionStorage.getItem('LICENSE_HISTORY_ITEM');
    if (saved) {
      setLicenseInfo(JSON.parse(saved));
    }
  }, []);

  const url = `api/license/${licenseId}/usage-history?countPerPage=${countPerPage}&currentPage=${currentPage}&searchType=${
    searchKey || ''
  }&searchValue=${searchKeyword || ''}&fromDate=${dateRange.startDate || ''}&searchDateType=${
    searchDateType || ''
  }&toDate=${dateRange.endDate || ''}`;
  const { data, error } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  if (error) {
    return <div>failed to load</div>;
  }

  if (!data) {
    return <div>loading...</div>;
  }

  const detailHistories: any[] = [];
  if (data) {
    if (data.code === '200') {
      const { countPerPage, currentPage, totalCount } = data.result.condition;
      const startNum = getStartNumber(totalCount, countPerPage, currentPage);
      data.result.results.map((item: LicenseDetail, index: number) => {
        const customName = item.lastName === 'System' ? item.lastName : '**** ' + item.lastName;
        detailHistories.push({
          no: startNum - index,
          analysis_date: item.createdDatetime,
          id: item.userId,
          name: customName,
        });
      });
    }
  }

  return (
    <Popup
      header={{
        title: 'LicenseInfo History Detail',
        desc: (
          <LicenseInfoDetail>{`Expiration Date : ${licenseInfo?.expiration_date || '-'} | Number of user available : ${
            licenseInfo.user
          } |   Number of analysis available :  ${licenseInfo.count}`}</LicenseInfoDetail>
        ),
      }}
      body={
        <>
          <Filters styles={FilterStyle} searchConditions={valueState} setSearchConditions={setValueState} />
          <Worklist
            headers={[
              { label: 'No', data_label: 'no' },
              { label: 'Analysis Date', data_label: 'analysis_date' },
              { label: 'User ID', data_label: 'id' },
              { label: 'Name', data_label: 'name' },
            ]}
            data={{ dataArray: detailHistories }}
          />
          <Pagination
            conditions={data.result?.condition ?? pageConditionsValue}
            setConditions={setPageConditionsValue}
          />
        </>
      }
      footer={
        <Sub1Button onClick={window.close} styles={DismissButtonStyle}>
          Close
        </Sub1Button>
      }
    />
  );
};

export default LicenseDetail;
